<template>
  <div>
    <div class="app-block p-md m-md">
      <h3 class="heading-line title is-4 has-text-weight-light"><span
          :class="'school-title-'+schoolSlug">4 - Documents</span>
      </h3>
      <div class="content app-documents">
        <div class="columns has-text-centered is-multiline">
          <div class="column">
            <div class="doc-type">
              <h4 class="doc-type-title">Pièce d'identité</h4>
              <div class="doc-type-subtitle">Carte d'identité nationale, passeport et/ou titre de séjour
              </div>
            </div>

            <document-drop
                :key="maximumFiles(['identity-doc'], 3)"
                :candidate="candidate"
                :docType="'identity-doc'"
                :maxFiles="maximumFiles(['identity-doc'], 3)"
                :maxFilesize="5"
                v-on:success="fileAdded">
            </document-drop>
            <div class="doc-list m-t-md has-text-centered">
              <div v-for="doc in application.documents"
                   v-if="doc.document_type === 'identity-doc'"
                   :key="doc.id">
                            <span class="doc-filename"><a class="doc-remove" @click="deleteDocument(doc)"
                                                          v-if="!registered"><i
                                class="fa fa-trash"></i></a> <a
                                :href="'/api/candidate/document/'+doc.file_name+'?token='+user.token"
                                target="_blank">{{ doc.original_file_name }}</a></span>
              </div>
            </div>
          </div>

          <div class="column">
            <div class="doc-type">
              <h4 class="doc-type-title">Diplômes - Notes</h4>
              <div class="doc-type-subtitle">Derniers diplomes obtenus et relevés de notes significatifs
              </div>
            </div>

            <document-drop
                :key="maximumFiles(['cursus-doc','baccalaureat-doc'], 10)"
                :candidate="candidate"
                :docType="'cursus-doc'"
                :maxFiles="maximumFiles(['cursus-doc','baccalaureat-doc'], 10)"
                :maxFilesize="5"
                v-on:success="fileAdded">
            </document-drop>

            <div class="doc-list m-t-md has-text-centered">
              <div v-for="doc in application.documents"
                   v-if="doc.document_type === 'cursus-doc' || doc.document_type === 'baccalaureat-doc'"
                   :key="doc.id">
                            <span class="doc-filename"><a class="doc-remove" @click="deleteDocument(doc)"
                                                          v-if="!registered"><i
                                class="fa fa-trash"></i></a> <a
                                :href="'/api/candidate/document/'+doc.file_name+'?token='+user.token"
                                target="_blank">{{ doc.original_file_name }}</a></span>
              </div>
            </div>

          </div>


        </div>

        <div class="columns has-text-centered">
          <div class="column">
            <div class="">
              <h4 class="">Documents complémentaires (facultatif)</h4>
            </div>
            <document-drop
                :key="maximumFiles(['other-doc'], 10)"
                :candidate="candidate"
                :docType="'other-doc'"
                :maxFiles="maximumFiles(['other-doc'], 10)"
                :maxFilesize="300"
                v-on:success="fileAdded">
            </document-drop>

            <div class="doc-list m-t-md">
              <div v-for="doc in application.documents"
                   v-if="doc.document_type === 'other-doc'"
                   :key="doc.id">
                            <span class="doc-filename">
                              <a class="doc-remove" @click="deleteDocument(doc)"
                                 v-if="!registered"><i
                                  class="fa fa-trash"></i></a> <a
                                :href="'/api/candidate/document/'+doc.file_name+'?token='+user.token"
                                target="_blank">{{ doc.original_file_name }}</a></span>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>

</template>

<script>
import {mapActions, mapGetters, mapState} from 'vuex'
import api from 'services/candidate'
import DocumentDrop from '../../../components/DocumentsDrop'

export default {
  components: {
    DocumentDrop
  },
  data() {
    return {
      isLoading: '',
      errorMsg: '',
      totalDocuments: 0
    }
  },
  props: {
    schoolSlug: {type: String},
    candidate: {type: Object},
    application: {type: Object},
  },
  computed: {
    ...mapGetters({
      status: 'candidate/getStatus'
    }),
    ...mapState({
      user: 'auth'
    }),
    registered() {
      return this.application.registration && this.application.registration.registered_candidate
    },
  },
  methods: {
    ...mapActions({
      confirmDoc: 'candidate/documentComplete',
      removeDoc: 'candidate/removeDocument'
    }),
    toggleLoading: function () {
      this.isLoading = (this.isLoading === '') ? 'is-loading' : ''
    },
    maximumFiles(type, max) {
      let total = 0
      if (!_.isEmpty(this.application.documents)) {
        this.application.documents.forEach(function (doc, index) {
          if (type.includes(doc.document_type)) {
            total++
          }
        })
        return max - total
      }
      return max
    },
    fileAdded(response) {
      this.application.documents.push(response)
      this.$emit('send')
      this.totalDocuments++
    },
    removeDocument(file, error, xhr) {
      if (file.xhr && this.application.docComplete === false) {
        const response = JSON.parse(file.xhr.response)
        api.removeDocument(response).then((result) => {

        }).catch(e => {

        })
      }
    },
    deleteDocument(file) {
      api.removeDocument(file).then((result) => {

        if (result.status === 200) {
          let indexToRemove = -1;

          this.application.documents.forEach((doc, index) => {
            if (file.id === doc.id) {
              indexToRemove = index;
            }
          });

          if (indexToRemove !== -1) {
            this.application.documents.splice(indexToRemove, 1);
          }
        }

      }).catch(e => {

      })
    },
  }
}
</script>

<style lang="scss">

.doc-type {
  min-height: 5rem;
  color: #0f1e44
}

.doc-type-title {
  margin-bottom: 0.3em;
}

.doc-type-subtitle {
  color: #0f1e44;
  font-style: italic;
  font-size: 0.9rem;
  /*max-width: 15rem;*/
}
.doc-filename {
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  max-width: 17rem;
  display: block;
  font-style: italic;
}

.doc-remove {
  color: #0f1e44;

  &:hover {
    color: #a92222;
  }

}

</style>
